// extracted by mini-css-extract-plugin
export var statItem = "_lm-1";
export var statsRow = "_lm-0";